import { parse, serialize } from 'cookie'

const cookies = {
  parse: ctx => {
    if (ctx?.req?.headers?.cookie) {
      return parse(ctx.req.headers.cookie)
    }
    return {}
  },

  set: (ctx, name, value, options = {}) => {
    const header = serialize(name, value, options)
    const existing = ctx.res.getHeader('Set-Cookie') || []
    const previous = Array.isArray(existing) ? existing : [existing]
    ctx.res.setHeader('Set-Cookie', [...previous, header])
  },

  destroy: (ctx, name, options = {}) => {
    cookies.set(ctx, name, '', { ...options, maxAge: -1 })
  }
}

export default cookies
